/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './User/Login',
      },
    ],
  },
  {
    name: '首页',
    path: '/home',
    component: './Home',
  },
  {
    path: '/account',
    routes: [
      {
        name: 'acenter',
        path: '/account/center',
        component: './User/Center',
      },
      {
        name: 'asettings',
        path: '/account/settings',
        component: './User/Settings',
      },
    ],
  },
  {
    name: '系统管理',
    path: '/system',
    routes: [
      {
        name: '字典数据',
        path: '/system/dict-data/index/:id',
        component: './System/DictData',
      },
      {
        name: '菜单管理',
        path: '/system/menu',
        component: './System/Menu',
      },
      {
        name: '部门管理',
        path: '/system/dept',
        component: './System/Dept',
      },
      {
        name: '岗位管理',
        path: '/system/post',
        component: './System/Post',
      },
      {
        name: '用户管理',
        path: '/system/user',
        component: './System/User',
      },
      {
        name: '分配用户',
        path: '/system/role-auth/user/:id',
        component: './System/Role/authUser',
      },
      {
        name: '角色管理',
        path: '/system/role',
        component: './System/Role',
      },
      {
        name: '字典管理',
        path: '/system/dict',
        component: './System/Dict',
      },
      {
        name: '参数配置',
        path: '/system/config',
        component: './System/Config',
      },
      {
        name: '通知公告',
        path: '/system/notice',
        component: './System/Notice',
      },
    ],
  },
  {
    name: '系统监控',
    path: '/monitor',
    routes: [
      {
        name: '任务日志',
        path: '/monitor/job-log/index/:id',
        component: './Monitor/JobLog',
      },
      {
        name: '在线用户',
        path: '/monitor/online',
        component: './Monitor/Online',
      },
      {
        name: '系统监控',
        path: '/monitor/server',
        component: './Monitor/Server',
      },
      {
        name: '操作日志',
        path: '/monitor/operlog',
        component: './Monitor/Operlog',
      },
      {
        name: '报错日志',
        path: '/monitor/error-log',
        component: './Monitor/ErrorLog',
      },
      {
        name: '错误告警',
        path: '/monitor/errNotice',
        component: './Monitor/ErrNotice',
      },
    ],
  },
  {
    name: '系统工具',
    path: '/tool',
    routes: [
      {
        name: '代码生成',
        path: '/tool/gen',
        component: './Tool/Gen',
      },
      {
        name: '导入表',
        path: '/tool/gen/import',
        component: './Tool/Gen/import',
      },
      {
        name: '编辑表',
        path: '/tool/gen/edit',
        component: './Tool/Gen/edit',
      },
    ],
  },
  {
    name: '短剧管理',
    path: '/movie',
    routes: [
      {
        name: '短剧列表',
        path: 'list',
        component: './Movie/Detail',
      },
      {
        name: '剧集管理',
        path: '/movie/video',
        component: './Movie/Video',
      },
      {
        name: '标签管理',
        path: 'tag',
        component: './Movie/Tag',
      },
      {
        name: '分类管理',
        path: 'category',
        component: './Movie/Category',
      },
      {
        name: '首页 Tab 配置',
        path: 'home-tab',
        component: './Movie/HomeTab',
      },
      {
        name: '短剧详情',
        path: '/movie/detail',
        component: './Movie/Detail',
      },
      {
        name: '地区管理',
        path: '/movie/area',
        component: './Movie/Area',
      },
      {
        name: '音迅管理',
        path: '/movie/audio',
        component: './Movie/Audio',
      },
      {
        name: '翻译',
        path: '/movie/translate',
        component: './Movie/Translate',
      },
      {
        name: '轮播图管理',
        path: '/movie/banner',
        component: './Movie/Banner',
      },
      {
        name: 'home配置',
        path: '/movie/homeConfig',
        component: './Movie/homeConfig',
      },
    ],
  },
  {
    name: '用户管理',
    path: '/shortDramaUser',
    routes: [
      {
        name: '收藏管理',
        path: '/shortDramaUser/collect',
        component: './ShortDramaUser/Collect',
      },
      {
        name: '观看历史',
        path: '/shortDramaUser/history',
        component: './ShortDramaUser/History',
      },
    ],
  },
  {
    name: '用户管理',
    path: '/short-drama-user',
    routes: [
      {
        name: 'APP用户',
        path: 'app-user',
        component: './ShortDramaUser/AppUser',
      },
      {
        name: '用户行为日志',
        path: 'action-log',
        component: './ShortDramaUser/ActionLog',
      },
      {
        name: '用户支付行为统计',
        path: 'pay-event-stat',
        component: './ShortDramaUser/PayEventStat',
      },
      {
        name: '版本统计',
        path: 'version-stat',
        component: './ShortDramaUser/VersionStat',
      },
      {
        name: 'APP崩溃日志',
        path: 'crash-log',
        component: './ShortDramaUser/CrashLog',
      },
      {
        name: '广告回传日志',
        path: 'ad-callback-log',
        component: './ShortDramaUser/AdCallbackLog',
      },
    ],
  },
  {
    name: '客服中心',
    path: '/customer-service',
    routes: [
      {
        name: '客服统计',
        path: 'service-statistics',
        component: './CustomerService/ServiceStatistics',
      },
      {
        name: '客诉统计',
        path: 'complaint-statistics',
        component: './CustomerService/ComplaintStatistics',
      },
      {
        name: '用户反馈',
        path: 'feedback',
        component: './ShortDramaUser/FeedBack',
      },
      {
        name: '退订申请统计',
        path: 'statistics',
        component: './Unsubscribe/Statistics',
      },
      {
        name: '收件箱',
        path: 'receive',
        component: './Email/Receive',
      },
      {
        name: '发件箱',
        path: 'send',
        component: './Email/Send',
      },
    ],
  },
  {
    name: '页面配置',
    path: '/page-config',
    component: './PageConfig',
  },
  {
    name: '付费管理',
    path: '/pay-template',
    routes: [
      {
        name: '付费计划管理',
        path: 'pay-manager',
        component: './PayTemplate/PayManager',
      },
      {
        name: '金额模板',
        path: 'pay-amount',
        component: './PayTemplate/Amount',
      },
      {
        name: '付费模板',
        path: 'pay-poid',
        component: './PayTemplate/Paid',
      },
      {
        name: '内购产品',
        path: 'pay-product',
        component: './PayTemplate/Product',
      },
      {
        name: '订阅模版',
        path: 'pay-subscribe',
        component: './PayTemplate/Subscribe',
      },
    ],
  },
  {
    name: '退订申请管理',
    path: '/unsubscribe',
    routes: [
      {
        name: '退订申请统计',
        path: '/unsubscribe/statistics',
        component: './Unsubscribe/Statistics',
      },
      {
        name: '退订申请',
        path: '/unsubscribe/list',
        component: './Unsubscribe/List',
      },
    ],
  },
  {
    name: '邮件系统',
    path: '/email',
    routes: [
      {
        name: '发件域名管理',
        path: 'email-domain',
        component: './Email/EmailDomain',
      },
      {
        name: '收件域名管理',
        path: 'email-receive',
        component: './Email/EmailReceive',
      },
      {
        name: '邮件模版管理',
        path: 'email-template',
        component: './Email/EmailTemplate',
      },
    ],
  },
  {
    name: '投放链接',
    path: '/devote-link',
    component: './Devote',
  },
  {
    name: '签到管理',
    path: '/sign-in',
    routes: [
      {
        name: '签到规则',
        path: 'sign-in-rule',
        component: './SignIn/SignInRule',
      },
      {
        name: '签到规则详情',
        path: 'sign-in-rule-info',
        component: './SignIn/RuleInfo',
      },
    ],
  },
  {
    name: '充值金币规则',
    path: '/coin-rule',
    component: './CoinRule',
  },
  {
    name: '金币活动',
    path: '/coin-activity',
    routes: [
      {
        name: '活动管理',
        path: '/coin-activity/activity',
        component: './CoinActivity/Activity',
      },
      {
        name: '规则管理',
        path: '/coin-activity/rule',
        component: './CoinActivity/Rule',
      },
      {
        name: '参与记录',
        path: '/coin-activity/log',
        component: './CoinActivity/Log',
      },
      {
        name: '观看任务记录',
        path: '/coin-activity/watch',
        component: './CoinActivity/Watch',
      },
    ],
  },
  {
    name: 'APP多语言配置',
    path: '/app-language',
    component: './AppLanguage',
  },
  {
    name: 'pixel管理',
    path: '/facebook-pixel',
    component: './FacebookPixel',
  },
  {
    name: '任务中心',
    path: '/task-center',
    component: './TaskCenter',
  },
  {
    name: '消息推送',
    path: '/message-push',
    routes: [
      {
        name: '任务管理',
        path: 'task',
        component: './MessagePush/Task',
      },
      {
        name: '即时推送',
        path: 'immediate-push',
        component: './MessagePush/ImmediatePush',
      },
      {
        name: '推送模板',
        path: 'template',
        component: './MessagePush/Template',
      },
      {
        name: '推送记录',
        path: 'record',
        component: './MessagePush/Record',
      },
    ],
  },
  {
    name: '金币发放记录',
    path: '/task-record',
    component: './TaskRecord',
  },
  {
    name: '订单数据',
    path: '/order-data',
    component: './OrderData',
  },
  {
    name: '广告收益',
    path: '/ad-revenue',
    component: './AdRevenue',
  },
  {
    path: '/revenue-detail',
    redirect: '/ad-revenue?tab=detail',
  },
  {
    name: '数据分析',
    path: '/data-analysis',
    routes: [
      {
        name: '短剧分析',
        path: '/data-analysis/series-analysis',
        component: './DataAnalysis/SeriesAnalysis',
      },
      {
        name: '多语言分析',
        path: '/data-analysis/series-analysis/i18n/:movieId',
        component: './DataAnalysis/SeriesAnalysis/I18nAnalysis',
        hideInMenu: true,
      },
    ],
  },
  {
    name: '系统参数配置',
    path: 'moive-config',
    component: './Movie/Config',
  },
];
